import styled from "styled-components";

export const Flex = styled.div<{columnGap?: string}>`
  display: flex;
  column-gap: ${(props) => props.columnGap ?? "0px"};
  align-items: baseline;
`;
